<ngb-carousel *ngIf="banners && banners.length > 1">
    <ng-template ngbSlide *ngFor="let banner of banners">
        <a [href]="banner.link != null ? banner.link : ''" target="_blank">
            <img class="main-banner-image" loading="lazy" [src]="imageHelper.getImageLocation(banner.imageToken)"
                [alt]="banner.altText | titlecase">
        </a>
    </ng-template>
</ngb-carousel>
<a *ngIf="banner && banners && banners.length <= 1" loading="lazy" [href]="banner.link != null ? banner.link : ''" target="_blank">
    <img class="main-banner-image" [src]="imageHelper.getImageLocation(banner.imageToken)" [alt]="banner.altText | titlecase" />
</a>